import React, { useState } from 'react';

export default function VoucherAdjustForm({ voucher, onAdjust, busy }) {
  const [hours, setHours] = useState('');
  const [note, setNote] = useState('');
  const [error, setError] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    const nextHours = Number(hours);
    setError('');

    if (!nextHours) {
      setError('Introduce una cantidad válida.');
      return;
    }

    if (nextHours < 0 && voucher.hoursAvailable + nextHours < 0) {
      setError('No hay horas disponibles suficientes para aplicar ese ajuste.');
      return;
    }

    try {
      await onAdjust({
        hours: nextHours,
        note: note || 'Ajuste manual',
      });

      setHours('');
      setNote('');
    } catch (requestError) {
      setError(requestError?.message || 'No se pudo guardar el ajuste.');
    }
  }

  return (
    <form onSubmit={handleSubmit} className="rounded-[24px] border border-[var(--app-border)] bg-[rgba(248,250,252,0.82)] p-5 space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-slate-700">Ajuste manual</p>
        <span className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Usa `+` para sumar y `-` para restar</span>
      </div>

      <div className="grid md:grid-cols-[160px_1fr_auto] gap-3">
        <input
          type="number"
          step="1"
          value={hours}
          onChange={(event) => setHours(event.target.value)}
          placeholder="+2 / -1"
          className="app-input-compact rounded-2xl px-4 py-3 text-lg font-semibold"
        />
        <input
          type="text"
          value={note}
          onChange={(event) => setNote(event.target.value)}
          placeholder={`Motivo del ajuste de ${voucher.voucherCode}`}
          className="app-input-compact rounded-2xl px-4 py-3"
        />
        <button
          type="submit"
          disabled={busy}
          className="rounded-2xl bg-slate-900 hover:bg-slate-800 text-white font-semibold px-5 py-3 disabled:opacity-60"
        >
          {busy ? 'Guardando...' : 'Guardar ajuste'}
        </button>
      </div>

      {error && (
        <p className="text-sm font-medium text-red-600">{error}</p>
      )}
    </form>
  );
}
